var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.762,
    height: 32.461,
    viewBox: "0 0 91.762 32.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28890",
    "data-name": "Group 28890",
    transform: "translate(-2323.974 -210.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140251",
    "data-name": "Path 140251",
    d: "M314.457,8.8l3.33-.022v1.34a19.528,19.528,0,0,1,7.432-2.564V9.382a17.878,17.878,0,0,1,4.285-.369l-.017,3.09a7.249,7.249,0,0,0-2.288.048l2.4.711V15l1.649-1.833,1.905.595-1.111-1.9,8.42-10.683V5.972l-4.954,6.105,4.014,6.469-7.358-2.07-5.35,6.252v-7.8l-1.657-.527v1.078a9,9,0,0,0-7.548,7.49v9.88h-3.156V21.544a18.043,18.043,0,0,1,8.286-8.519l4.517,1.49v6.912l4.675-5.5,6.653,1.966L334.938,12.1l5.143-6.386v-3.3l-7.5,9.55,1.662,2.637-2.961-.875-2.1,2.468v-3.07l-3.436-1.134a15.377,15.377,0,0,1,2.427-.352c.97-.063,1.007.009,1.007.009V9.41s.067-.091-1.154-.011a18.014,18.014,0,0,0-13.571,7.812Zm-5.413.036,3.169-.021V32.854h-3.169Z",
    transform: "translate(2075.119 209.631)",
    fill: "none",
    stroke: "#0c206d",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140246",
    "data-name": "Path 140246",
    d: "M114.43,30.066v2.9H109.3s-8.739.116-8.739-8.83c0-3.023.007-6.6.015-10h3.082V24.7a5.534,5.534,0,0,0,4.589,5.363ZM114.4,14.133V17.11h-5.216v6.324a1.217,1.217,0,0,0,1.311,1.311h3.934v3.077h-5.968a3.358,3.358,0,0,1-2.558-3.151V14.133Zm-8.5-12.7h3.252v7.49H114.4V11.89h-8.5Zm-5.283,0h3.039V11.89h-3.076c.017-5.721.036-10.457.036-10.457",
    transform: "translate(2243.01 209.433)",
    fill: "#0c206d",
    stroke: "#707070",
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140247",
    "data-name": "Path 140247",
    d: "M114.43,30.066v2.9H109.3s-8.739.116-8.739-8.83c0-3.023.007-6.6.015-10h3.082V24.7a5.534,5.534,0,0,0,4.589,5.363ZM114.4,14.133V17.11h-5.216v6.324a1.217,1.217,0,0,0,1.311,1.311h3.934v3.077h-5.968a3.358,3.358,0,0,1-2.558-3.151V14.133Zm-8.5-12.7h3.252v7.49H114.4V11.89h-8.5Zm-5.283,0h3.039V11.89h-3.076C100.6,6.169,100.621,1.433,100.621,1.433Z",
    transform: "translate(2243.01 209.433)",
    fill: "none",
    stroke: "#0c206d",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140248",
    "data-name": "Path 140248",
    d: "M185.285,41.868a6.979,6.979,0,0,1,6.979,6.9V60.909h-2.905V48.663a3.9,3.9,0,1,0-3.913,4,3.871,3.871,0,0,0,1.669-.376v3.241a8.167,8.167,0,0,1-1.83.295,6.979,6.979,0,1,1,0-13.959m-12.452,6.844a12.561,12.561,0,0,1,25.085-.963V60.924h-3.41V48.749a9.223,9.223,0,1,0-9.223,9.321,9.415,9.415,0,0,0,1.83-.245v3.329a12.569,12.569,0,0,1-14.282-12.443",
    transform: "translate(2184.811 181.474)",
    fill: "#0c206d",
    stroke: "#707070",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140249",
    "data-name": "Path 140249",
    d: "M185.285,41.868a6.979,6.979,0,0,1,6.979,6.9V60.909h-2.905V48.663a3.9,3.9,0,1,0-3.913,4,3.871,3.871,0,0,0,1.669-.376v3.241a8.167,8.167,0,0,1-1.83.295,6.979,6.979,0,1,1,0-13.959Zm-12.452,6.844a12.561,12.561,0,0,1,25.085-.963V60.924h-3.41V48.749a9.223,9.223,0,1,0-9.223,9.321,9.415,9.415,0,0,0,1.83-.245v3.329a12.569,12.569,0,0,1-14.282-12.443Z",
    transform: "translate(2184.811 181.474)",
    fill: "none",
    stroke: "#0c206d",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140250",
    "data-name": "Path 140250",
    d: "M314.457,8.8l3.33-.022v1.34a19.528,19.528,0,0,1,7.432-2.564V9.382a17.878,17.878,0,0,1,4.285-.369l-.017,3.09a7.249,7.249,0,0,0-2.288.048l2.4.711V15l1.649-1.833,1.905.595-1.111-1.9,8.42-10.683V5.972l-4.954,6.105,4.014,6.469-7.358-2.07-5.35,6.252v-7.8l-1.657-.527v1.078a9,9,0,0,0-7.548,7.49v9.88h-3.156V21.544a18.043,18.043,0,0,1,8.286-8.519l4.517,1.49v6.912l4.675-5.5,6.653,1.966L334.938,12.1l5.143-6.386v-3.3l-7.5,9.55,1.662,2.637-2.961-.875-2.1,2.468v-3.07l-3.436-1.134a15.377,15.377,0,0,1,2.427-.352c.97-.063,1.007.009,1.007.009V9.41s.067-.091-1.154-.011a18.014,18.014,0,0,0-13.571,7.812Zm-5.413.036,3.169-.021V32.854h-3.169Z",
    transform: "translate(2075.119 209.631)",
    fill: "#0c206d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140252",
    "data-name": "Path 140252",
    d: "M18.072,44.994V48H12.421c-1.021,0,0,.73,0,.73l1.892,1.34s4.664,3.116,4.664,7.287c0,6.143-6.934,6.295-6.934,6.295H1.026V60.834H11.815c3.632.24,5.345-3.483,3.057-6.373a4.848,4.848,0,0,0-.391-.437L6.917,47.979a5.631,5.631,0,0,1-1.29-1.287c-.179-.937-.189-1.5,1.005-1.7Zm0-5.24v3H6.467a3.354,3.354,0,0,0-3.011,2.176c-.677,2.114.5,3.589,2.069,4.813l7.451,5.951c1.1,1.2.968,3.106-1.059,2.9H1.026V55.547s5.477.087,5.739,0c1.129-.376,0-1.2,0-1.2s-2.434-1.908-3.76-3A6.021,6.021,0,0,1,.412,46.137c0-5.946,6.819-6.383,6.819-6.383Z",
    transform: "translate(2323.662 178.572)",
    fill: "#0c206d",
    stroke: "#707070",
    strokeWidth: 0.2,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140253",
    "data-name": "Path 140253",
    d: "M18.072,44.994V48H12.421c-1.021,0,0,.73,0,.73l1.892,1.34s4.664,3.116,4.664,7.287c0,6.143-6.934,6.295-6.934,6.295H1.026V60.834H11.815c3.632.24,5.345-3.483,3.057-6.373a4.848,4.848,0,0,0-.391-.437L6.917,47.979a5.631,5.631,0,0,1-1.29-1.287c-.179-.937-.189-1.5,1.005-1.7Zm0-5.24v3H6.467a3.354,3.354,0,0,0-3.011,2.176c-.677,2.114.5,3.589,2.069,4.813l7.451,5.951c1.1,1.2.968,3.106-1.059,2.9H1.026V55.547s5.477.087,5.739,0c1.129-.376,0-1.2,0-1.2s-2.434-1.908-3.76-3A6.021,6.021,0,0,1,.412,46.137c0-5.946,6.819-6.383,6.819-6.383Z",
    transform: "translate(2323.662 178.572)",
    fill: "none",
    stroke: "#0c206d",
    strokeMiterlimit: 3.864,
    strokeWidth: 0.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLogo);
export default __webpack_public_path__ + "static/media/star-logo.f9d482eeba8dc481dc1e499ecec957cb.svg";
export { ForwardRef as ReactComponent };